/* eslint-disable import/no-unresolved */
import React from "react";
import { bool, node, shape } from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { selectors as sessionSelectors } from "reducers/session";
import { selectors as configSelectors } from "reducers/config";

import { getLoginStep3Path, getPostLoginHomePath, getUnauthenticatedLoginPath } from "util/v3UxConfig";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

import PrivateLayout from "v3/layout/PrivateLayout";

/**
 * Shell autenticado v3: layout privado + contenido arbitrario (p. ej. agenda).
 * Mismas guardas que {@link V3PrivateDashboardRoute}; opcional `authorizedRoute` (permiso).
 */
function V3PrivateShellRoute({
    hasActiveSession,
    activeEnvironment,
    uxDashboardImprovements,
    uxLoginImprovements,
    authorizedRoute,
    children,
}) {
    const loginPath = getUnauthenticatedLoginPath(uxLoginImprovements);

    if (!hasActiveSession) {
        return <Redirect to={loginPath} />;
    }
    if (!uxDashboardImprovements) {
        return <Redirect to={getPostLoginHomePath(false)} />;
    }
    if (!activeEnvironment) {
        return <Redirect to={getLoginStep3Path(uxLoginImprovements)} />;
    }
    if (!authorizedRoute) {
        return <Redirect to={getPostLoginHomePath(uxDashboardImprovements)} />;
    }

    return <PrivateLayout>{children}</PrivateLayout>;
}

V3PrivateShellRoute.propTypes = {
    hasActiveSession: bool.isRequired,
    activeEnvironment: shape({}),
    uxDashboardImprovements: bool.isRequired,
    uxLoginImprovements: bool.isRequired,
    authorizedRoute: bool,
    children: node.isRequired,
};

V3PrivateShellRoute.defaultProps = {
    activeEnvironment: null,
    authorizedRoute: true,
};

const mapStateToProps = (state) => ({
    hasActiveSession: sessionSelectors.isLoggedIn(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    uxDashboardImprovements: isUxDashboardImprovementsEnabled(),
    uxLoginImprovements: !!configSelectors.getConfigKey(state, "frontend.UXImprovements.Login.functionalities"),
});

export default connect(mapStateToProps)(V3PrivateShellRoute);
